import PageSection from '@sayyesschool/frontend/components/page-section';

import MaterialForm from '@/components/materials/material-form';

export default function MaterialDetails({ material, onUpdate }) {
    return (
        <PageSection
            className="MaterialDetails"
            title="Детали"
        >
            <MaterialForm
                material={material}
                onSubmit={onUpdate}
            />
        </PageSection>
    );
}